/**
 * Angular Import.
 */
import { Component, Input, EventEmitter, Output } from '@angular/core';
/**
 * Owl Carousel Import.
 */
import { OwlOptions } from 'ngx-owl-carousel-o';
/**
 * Import service.
 */
import {NewLanguageService} from '../../dataservices/new-language/new-language.service';

/**
 * Connection suggestion filter.
 */
@Component({
  selector: 'app-connection-sugg-filter',
  templateUrl: './connection-sugg-filter.component.html',
  styleUrls: ['./connection-sugg-filter.component.scss']
})
export class ConnectionSuggFilterComponent {

  /**
   * Suggesting filter data.
   */
  @Input() suggestionFilter;

  /**
   * Filter index.
   */
  @Input() filterIndex: number;

  /**
   * Connection filter emitter.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Output() connectionFilter = new EventEmitter<any>();

  /**
   * Drug nudge specialty carousel property.
   */
  customOptionsNudge: OwlOptions = {
    loop: false,
    touchDrag: true,
    navSpeed: 700,
    navText: ['<i class="prev-slider position-absolute"></i>', '<i class="next-slider position-absolute"></i>'],
    margin: 6,
    autoWidth: true,
    dots: false,
    nav: true,
    responsive : {
      0: {
        items: 1.25
      },
      250: {
        items: 1.4
      },
      290: {
        items: 1.6
      },
      420: {
        items: 2.25
      },
      500: {
        items: 2.8
      }
    }
  };

  /**
   * Function used to import services from outside of this component
   */
  constructor(public mls: NewLanguageService) { }

  /**
   * Output funcrion for filter.
   */
  applyFilter(Index, data): void {
    this.filterIndex = Index;
    this.connectionFilter.emit( data);
  }
}
